import '../Styles/Order.css';
import '../Styles/CustomerOrders.css';
import bckg from "../Images/order.svg"
import Navbar from '../Components/Navbar';
import { useTranslation } from 'react-i18next';
import ErrorModal from '../Components/ErrorModal';
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { RiArrowRightSFill, RiArrowLeftSFill } from 'react-icons/ri';
import { AiOutlineSearch } from 'react-icons/ai';
import { useRef, useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { addComplaint, allBranches } from '../api';

function AddComplaint(props) {
  const customerPhone = localStorage.getItem("customerPhone");

  const { t, i18n } = useTranslation();
  const [about, setAbout] = useState("time");
  const [loading, setLoading] = useState(false);
  const [arMsg, setArMsg] = useState()
  const [enMsg, setEnMsg] = useState()
  const [errModal, setErrModal] = useState(false)
  const [notesValue, setNotesValue] = useState("")
  const [isBranchComplaint, setIsBranchComplaint] = useState(false);
  const [branches, setBranches] = useState([]);
  const [isBranchDropdownOpen, setIsBranchDropdownOpen] = useState(false);
  const [branchSearch, setBranchSearch] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState("");
  const [branchesLoading, setBranchesLoading] = useState(false);
  const notesRef = useRef();
  const branchDropdownRef = useRef(null);
  let history = useNavigate();

  const customerId = localStorage.getItem("customerId");
  const isArabic = i18n.language === "ar";

  const filteredBranches = useMemo(() => {
    const query = branchSearch.trim().toLowerCase();
    if (!query) return branches;
    return branches.filter(
      (branch) =>
        branch.arName.toLowerCase().includes(query) ||
        branch.enName.toLowerCase().includes(query)
    );
  }, [branches, branchSearch]);

  const selectedBranch = useMemo(
    () => branches.find((branch) => String(branch.id) === String(selectedBranchId)),
    [branches, selectedBranchId]
  );

  const selectedBranchLabel = selectedBranch
    ? (isArabic ? selectedBranch.arName : selectedBranch.enName)
    : null;

  const chooseBranchPlaceholder = t("profile.chooseBranchComplaint");
  const branchSearchPlaceholder = t("profile.searchBranchComplaint");
  const noBranchesText = t("profile.noBranchesComplaint");

  useEffect(() => {
    document.body.classList.add("add-complaint-active");
    return () => document.body.classList.remove("add-complaint-active");
  }, []);

  useEffect(() => {
    if (!isBranchComplaint || branches.length > 0) return;

    const token = localStorage.getItem("token");
    setBranchesLoading(true);

    allBranches(token)
      .then((response) => {
        setBranches(response.data.data);
        setBranchesLoading(false);
      })
      .catch(function (error) {
        setBranchesLoading(false);
        if (error.response?.status === 401) {
          history("/");
        } else {
          setArMsg("حدث خطأ");
          setEnMsg("Something went wrong");
          setErrModal(true);
          setTimeout(function () {
            setErrModal(false);
          }, 2500);
        }
      });
  }, [isBranchComplaint, branches.length, history]);

  useEffect(() => {
    if (!isBranchDropdownOpen) return;

    function handleClickOutside(event) {
      if (
        branchDropdownRef.current &&
        !branchDropdownRef.current.contains(event.target)
      ) {
        setIsBranchDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isBranchDropdownOpen]);

  function handleBranchComplaintChange(e) {
    const checked = e.target.checked;
    setIsBranchComplaint(checked);
    if (!checked) {
      setSelectedBranchId("");
      setBranchSearch("");
      setIsBranchDropdownOpen(false);
    }
  }

  function toggleBranchDropdown() {
    if (branchesLoading) return;
    setIsBranchDropdownOpen((open) => !open);
  }

  function handleSelectBranch(branch) {
    setSelectedBranchId(String(branch.id));
    setBranchSearch("");
    setIsBranchDropdownOpen(false);
  }

  function showValidationError(arMessage, enMessage) {
    setArMsg(arMessage);
    setEnMsg(enMessage);
    setErrModal(true);
    setLoading(false);
    setTimeout(function () {
      setErrModal(false);
    }, 2500);
  }

  function handleComplaint() {
    setLoading(true)
    const token = localStorage.getItem("token");

    if (notesRef.current.value === '') {
      showValidationError(
        "من فضلك أدخل تفاصيل الشكوي",
        "Please enter the complaint details"
      );
      return;
    }

    if (isBranchComplaint && !selectedBranchId) {
      showValidationError(
        "من فضلك اختر الفرع",
        "Please select a branch"
      );
      return;
    }

    const values = {
      about,
      msg: notesRef.current.value,
      ...(isBranchComplaint && selectedBranchId
        ? { branchId: Number(selectedBranchId) }
        : {}),
    };

    addComplaint(token, customerId, values).then((response) => {
      if (response.data.message === "success") {
        history("/customer-complaints")
      } else {
        showValidationError("حدث خطأ", "Something went wrong");
      }

    }).catch(function (error) {
      if (error.response.status === 401) {
        history("/")
      }
      else if (error.response.status === 403) {
        props.setErr(true)
        props.setMsg(t('validation.noPermissionAction'))
        props.setStyle({ top: "50%" })

        setTimeout(function () {

          props.setErr(false)
          setLoading(false)


        }, 2500)
      }
      else {
        showValidationError("حدث خطأ", "Something went wrong");
      }

    })
  };

  function handleNotes(e) {

    if (!e.target.value.includes("٠") && !e.target.value.includes("١") && !e.target.value.includes("٢") && !e.target.value.includes("٣") && !e.target.value.includes("٤") && !e.target.value.includes("٥") && !e.target.value.includes("٦") && !e.target.value.includes("٧") && !e.target.value.includes("٨") && !e.target.value.includes("٩")) {

      setNotesValue(e.target.value)

    }

  }

  const branchComplaintLabel =
    isArabic
      ? "الشكوى متعلقة بفرع معين"
      : "The complaint pertains to a specific branch.";

  return (
    <div className="addComplaintPage">

      {errModal ? <ErrorModal setModal={setErrModal} msg={i18n.language == "ar" ? arMsg : enMsg} /> : null}
      <div className='compContaienr'>

        <div className='navigateOrder'>
          <a href='/'>{t("addOrder.search")}</a>
          {i18n.language == "ar" ?
            <RiArrowLeftSFill /> : <RiArrowRightSFill />}
          <a href='/customer-orders' className='userData'> {t("profile.cstmr")} &nbsp; ( {customerPhone} )</a>
          {i18n.language == "ar" ?
            <RiArrowLeftSFill /> : <RiArrowRightSFill />}
          <a>{t("profile.addNewComp")}</a>

        </div>
        <p style={{ fontWeight: "700" }} className='orderTitle'>{t("profile.addNewComp")}</p>


        <div style={{ marginBottom: "5em" }} className='row gy-4'>
          <div className='col-sm-7 '>
            <div className='p-3 complaintBody'>
              <p style={{ marginTop: "0" }}> {t("profile.c-type")}</p>

              <div className="row gy-2">
                <div className="col">
                  <input
                    type="radio"
                    id="about-time"
                    name="about"
                    value="time"
                    defaultChecked={true}
                    onChange={(e) => setAbout(e.target.value)}
                  />
                  <label htmlFor="about-time">{t("profile.time")}</label>
                </div>

                <div className="col">
                  <input
                    type="radio"
                    id="about-clean"
                    name="about"
                    value="clean"
                    onChange={(e) => setAbout(e.target.value)}
                  />
                  <label htmlFor="about-clean">{t("profile.cleaness")}</label>
                </div>

                <div className="col">
                  <input
                    type="radio"
                    id="about-quality"
                    name="about"
                    value="quality"
                    onChange={(e) => setAbout(e.target.value)}
                  />
                  <label htmlFor="about-quality">{t("profile.quality")}</label>
                </div>
              </div>

              <div className="col" style={{ marginTop: "1em" }}>
                <input
                  type="checkbox"
                  id="branch-complaint"
                  checked={isBranchComplaint}
                  onChange={handleBranchComplaintChange}
                />
                <label htmlFor="branch-complaint">{branchComplaintLabel}</label>
              </div>

              {isBranchComplaint ? (
                <div
                  className={`complaintBranchDropdown ${isBranchDropdownOpen ? "complaintBranchDropdown--open" : ""}`}
                  ref={branchDropdownRef}
                  dir={isArabic ? "rtl" : "ltr"}
                  style={{ marginTop: "1em" }}
                >
                  <button
                    type="button"
                    className="complaintBranchTrigger"
                    onClick={toggleBranchDropdown}
                    disabled={branchesLoading}
                    aria-expanded={isBranchDropdownOpen}
                    aria-haspopup="listbox"
                  >
                    <span
                      className={`complaintBranchTriggerLabel ${!selectedBranchLabel ? "complaintBranchTriggerLabel--placeholder" : ""}`}
                    >
                      {branchesLoading
                        ? (isArabic ? "جاري التحميل..." : "Loading...")
                        : (selectedBranchLabel || chooseBranchPlaceholder)}
                    </span>
                    <span className="complaintBranchTriggerArrow" aria-hidden="true">
                      {isArabic ? (
                        <RiArrowLeftSFill />
                      ) : (
                        <RiArrowRightSFill />
                      )}
                    </span>
                  </button>

                  {isBranchDropdownOpen ? (
                    <div className="complaintBranchMenu" role="listbox">
                      <div className="complaintBranchSearchWrap">
                        <input
                          type="text"
                          placeholder={branchSearchPlaceholder}
                          value={branchSearch}
                          onChange={(e) => setBranchSearch(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                          aria-label={branchSearchPlaceholder}
                        />
                        <AiOutlineSearch
                          className="complaintBranchSearchIcon"
                          size={22}
                        />
                      </div>

                      <ul className="complaintBranchList">
                        {branchesLoading ? (
                          <li className="complaintBranchListLoading">
                            <BeatLoader color="#AA2A31" loading size={10} />
                          </li>
                        ) : filteredBranches.length > 0 ? (
                          filteredBranches.map((branch) => {
                            const isSelected =
                              String(selectedBranchId) === String(branch.id);
                            return (
                              <li key={branch.id}>
                                <button
                                  type="button"
                                  role="option"
                                  aria-selected={isSelected}
                                  className={`complaintBranchListItem ${isSelected ? "complaintBranchListItem--selected" : ""}`}
                                  onClick={() => handleSelectBranch(branch)}
                                >
                                  {isArabic ? branch.arName : branch.enName}
                                </button>
                              </li>
                            );
                          })
                        ) : (
                          <li>
                            <p className="complaintBranchListEmpty">
                              {noBranchesText}
                            </p>
                          </li>
                        )}
                      </ul>
                    </div>
                  ) : null}
                </div>
              ) : null}

              <p>{t("profile.c-details")}</p>
              <textarea maxLength={265}
                value={notesValue} ref={notesRef} placeholder={t("profile.enterNote")} onChange={(e) => handleNotes(e)} />
            </div>


          </div>
          <div className='col-sm-5 '>

            <div className='p-3 complaintSend'>
              {loading ?
                <div style={{ height: "40vh" }} className='loader'>
                  <BeatLoader color={'#AA2A31'} loading={loading} size={30} /></div> :
                <>
                  <button onClick={handleComplaint} className=' sendComp'>

                    {t("profile.send")}</button>
                  <Link to="/customer-complaints">
                    <button className='prevComp'>{t("profile.previous")}</button></Link>

                </>}


            </div>


          </div>
        </div>
      </div>
    </div>

  );
}

export default AddComplaint;
